import React, { useState, useEffect } from 'react';
import { Link } from 'react-scroll';
import { Helmet } from 'react-helmet';
import './App.css';
import VehicleSection from './vehicle';
import Navbar from './navbar';
import NewestCarFleet from './new';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCar,
  faUserShield,
  faSmile,
  faLock,
  faPlaneDeparture,
  faTaxi,
  faGifts,
  faRoute,
  faGem,
  faUsers,
  faMapMarkedAlt,
  faPhone,
} from '@fortawesome/free-solid-svg-icons';
import { faFacebook, faWhatsapp, faInstagram } from '@fortawesome/free-brands-svg-icons';

const Popup = ({ onClose }) => (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div className="bg-white rounded-lg shadow-lg p-6 text-center max-w-sm w-full">
      <h2 className="text-lg font-bold mb-4">Get in Touch</h2>
      <p className="mb-6">Contact us now for quick assistance!</p>
      <div className="flex justify-around mb-6">
        <a href="tel:+916205499309" className="bg-red-500 text-white px-4 py-2 rounded-lg hover:bg-red-600 flex items-center space-x-2">
          <FontAwesomeIcon icon={faPhone} size="lg" />
          <span>Call Now</span>
        </a>
        <a href="https://wa.me/+916205499309" target="_blank" rel="noopener noreferrer" className="bg-green-500 text-white px-4 py-2 rounded-lg hover:bg-green-600 flex items-center space-x-2">
          <FontAwesomeIcon icon={faWhatsapp} size="lg" />
          <span>WhatsApp</span>
        </a>
      </div>
      <button onClick={onClose} className="text-red-500 font-bold hover:underline">
        Close
      </button>
    </div>
  </div>
);

const App = () => {
  const [isPopupVisible, setIsPopupVisible] = useState(true);

  useEffect(() => {
    const counters = document.querySelectorAll('.animate-count');
    const speed = 50;

    const countUp = (el) => {
      const target = +el.getAttribute('data-count');
      const updateCount = () => {
        const count = +el.innerText;
        const increment = target / speed;
        if (count < target) {
          el.innerText = Math.ceil(count + increment);
          setTimeout(updateCount, 20);
        } else {
          el.innerText = target;
        }
      };
      updateCount();
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          countUp(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.5 });

    counters.forEach((counter) => observer.observe(counter));
  }, []);

  return (
    <div className="App">
      <Helmet>
        <title>Shiv Shakti Travels - Car Rental in Ranchi</title>
        <meta name="description" content="Book car rental services in Ranchi with Shiv Shakti Travels. Local, outstation, airport pickup, and custom travel packages available." />
        <meta name="keywords" content="car rental Ranchi, Shiv Shakti Travels, Ranchi taxi, outstation cab Ranchi, wedding car rental" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta charSet="utf-8" />
        <link rel="canonical" href="https://shivshaktitravels.in" />
      </Helmet>

      {isPopupVisible && <Popup onClose={() => setIsPopupVisible(false)} />}
      <Navbar />

      <header id="home" className="relative bg-cover bg-no-repeat bg-center h-[70vh] flex items-center justify-center text-center" style={{ backgroundImage: "url('/header1.png')" }}>
        <div className="text-black px-4">
          <h1 className="text-5xl font-bold mb-4">Shiv Shakti Travels</h1>
          <p className="text-lg mb-6">Experience Ranchi's Best Car Rental Service</p>
          <Link to="vehicle" smooth duration={500} className="bg-red-500 text-white py-3 px-6 rounded-lg hover:bg-red-600 transition duration-300 cursor-pointer">
            Book Now
          </Link>
        </div>
      </header>

      <NewestCarFleet />

      <section id="services" className="bg-white py-12">
  <div className="container mx-auto">
    <h2 className="text-4xl text-center underline font-bold text-red-500 mb-10">Our Services</h2>
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
      {[
        { icon: faRoute, title: 'Round Trip Cabs', desc: 'Seamless roundtrip cab services.' },
        { icon: faTaxi, title: 'Local Rental', desc: 'Explore the city with ease.' },
        { icon: faPlaneDeparture, title: 'Airport Transfers', desc: 'Stress-free airport transfers.' },
        { icon: faGifts, title: 'Wedding Cars', desc: 'Luxury cars for special occasions.' },
        { icon: faCar, title: 'Tourist Packages', desc: 'Custom packages to scenic destinations.' },
        { icon: faGem, title: 'Luxury Cars', desc: 'Premium luxury cars for VIP clients.' },
        { icon: faUsers, title: 'Convoy Packages', desc: 'Special convoy packages for events and tours.' },
        { icon: faMapMarkedAlt, title: 'Custom Itineraries', desc: 'Plan your travel with tailor-made itineraries.' },
      ].map((service, index) => (
        <div
          key={index}
          className="p-6 border-red-500 rounded-lg shadow-lg hover:shadow-xl transition duration-300 text-center"
        >
          <FontAwesomeIcon icon={service.icon} size="3x" className="text-red-500 mb-4" />
          <h3 className="text-xl font-semibold text-black mb-2">{service.title}</h3>
          <p className="text-gray-700">{service.desc}</p>
        </div>
      ))}
    </div>
  </div>
</section>

      <VehicleSection />
      {/* Why Choose Us Section */}
 <section className="py-16 bg-white text-black">
        <div className="container mx-auto">
          <h2 className="text-4xl font-bold underline text-red-500 text-center mb-12">Our Priority</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              {
                icon: faCar,
                title: 'Well-Maintained Cars',
                desc: 'Wide range of well-maintained & clean cars.',
              },
              {
                icon: faUserShield,
                title: 'Highly Trained Drivers',
                desc: 'Verified drivers with experience on highways & hills.',
              },
              {
                icon: faSmile,
                title: 'Client Satisfaction',
                desc: 'Best routes, pricing, and services for your comfort.',
              },
              {
                icon: faLock,
                title: 'Privacy & Freedom',
                desc: 'Enjoy the privacy of having your own vehicle.',
              },
            ].map((item, index) => (
              <div key={index} className="p-6 text-center border-2 border-red-500 rounded-lg">
                <FontAwesomeIcon icon={item.icon} size="3x" className="text-red-500 mb-4" />
                <h3 className="text-xl font-bold">{item.title}</h3>
                <p>{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    
  



      <section id="packages" className="bg-white py-12">
  <div className="container mx-auto">
    <h2 className="text-4xl text-center underline font-bold text-red-500 mb-10">Our Packages</h2>
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
      {[
        { title: 'Dewri Mandir Package', desc: 'Perfect for one day tour in a Sedan / SUV .', price: '₹2800/3400' },
        { title: 'Netrahat Tour', desc: 'Ideal for creating memories with your loved ones in 3 days 2 night (Sedan/SUV).', price: '₹9750/11900' },
        { title: 'Rajrappa Mandir', desc: 'Perfect for one day tour in a Sedan / SUV.', price: '₹2800/3400' },
        { title: 'City Tour', desc: 'Explore City In One Day (8 hours 80 km).(sedan/SUV)', price: '₹2,000/2400/3000' },
        { title: 'Patratu Valley', desc: 'Discover the Beauty of Nature with your family.(sedan/SUV)', price: '₹2000/2700' },
        { title: 'Ranchi To Deoghar', desc: 'Perfect Package for family for Visiting both Deoghar and Basukinath Temple (2days 1Night) .(sedan/SUV)', price: '11000/12500' },
      ].map((packageItem, index) => (
        <div
          key={index}
          className="p-6 border border-red-500 rounded-lg shadow-lg hover:shadow-xl transition duration-300 text-center bg-white"
        >
          <h3 className="text-xl font-semibold text-black mb-4">{packageItem.title}</h3>
          <p className="text-gray-700 mb-4">{packageItem.desc}</p>
          <p className="text-red-500 font-bold text-lg">{packageItem.price}</p>
        </div>
      ))}
    </div>
  </div>
</section>

      <section id="destination" className="bg-white py-12">
  <div className="container mx-auto">
    <h2 className="text-4xl text-center underline font-bold text-red-500 mb-10">Top Destinations</h2>
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
      {[
        'Ranchi to Ramgarh',
        'Ranchi to Tarapith',
        'Ranchi to Dumka',
        'Ranchi to Deoghar',
        'Ranchi to Raipur',
        'Ranchi to Rourkela',
        'Ranchi to Jamshedpur',
        'Ranchi to Hazaribagh',
        'Ranchi to Bokaro',
        'Ranchi to Dhanbad',
        'Ranchi to Chaibasa',
        'Ranchi to Giridih',
        'Ranchi to Khunti',
        'Ranchi to Lohardaga',
        'Ranchi to Gumla',
        'Ranchi to Simdega',
        'Ranchi to Palamu',
        'Ranchi to Latehar',
        'Ranchi to Chatra',
        'Ranchi to Sahibganj',
        'Ranchi to Godda',
      ].map((destination, index) => (
        <div
          key={index}
          className="p-6 border border-red-500 rounded-lg shadow-lg hover:shadow-xl transition duration-300 bg-gray-100"
        >
          <h3 className="text-xl font-semibold text-black mb-2">{destination}</h3>
        </div>
      ))}
    </div>
  </div>
</section>

      {/* Enhanced Footer */}
      <footer id="footer" className="bg-white text-black pt-10 pb-6 mt-10 border-t border-gray-200">
        <div className="container mx-auto px-4 grid md:grid-cols-3 gap-6 text-center md:text-left">
          {/* Company Info */}
          <div>
            <h4 className="font-semibold text-lg mb-2">Shiv Shakti Travels</h4>
            <p className="text-gray-600">Reliable and affordable car rental service based in Ranchi. Local & outstation packages available.</p>
            <div className="flex justify-center md:justify-start mt-4 space-x-4">
              <a href="https://facebook.com" target="_blank" rel="noreferrer" aria-label="Facebook">
                <FontAwesomeIcon icon={faFacebook} className="text-red-500 text-xl" />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noreferrer" aria-label="Instagram">
                <FontAwesomeIcon icon={faInstagram} className="text-red-500 text-xl" />
              </a>
              <a href="https://wa.me/+916205499309" target="_blank" rel="noreferrer" aria-label="WhatsApp">
                <FontAwesomeIcon icon={faWhatsapp} className="text-green-500 text-xl" />
              </a>
            </div>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-semibold text-lg mb-2">Contact</h4>
            <p className="text-gray-600">📍 Kokar, Ranchi, Jharkhand - 834001</p>
            <p className="text-gray-600">📞 <a href="tel:+916205499309" className="hover:underline">+91 62054 99309</a></p>
            <p className="text-gray-600">✉️ <a href="mailto:shivshaktitravelcab@gmail.com" className="hover:underline">shivshaktitravelcab@gmail.com</a></p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-lg mb-2">Quick Links</h4>
            <ul className="text-gray-600 space-y-2">
              <li><Link to="home" smooth duration={500} className="hover:text-red-500 cursor-pointer">Home</Link></li>
              <li><Link to="vehicle" smooth duration={500} className="hover:text-red-500 cursor-pointer">Fleet</Link></li>
              <li><Link to="footer" smooth duration={500} className="hover:text-red-500 cursor-pointer">Contact Us</Link></li>
            </ul>
          </div>
        </div>

        <div className="text-center text-gray-500 text-sm mt-6">
          &copy; {new Date().getFullYear()} Shiv Shakti Travels. All Rights Reserved.
        </div>
      </footer>
    </div>
  );
};

export default App;
